export default __webpack_public_path__ + "static/media/perf.9290e7cd.png";